<template>
    <e-tooltip :label="formatDate(momentDatetime)">
        <span :class="isLarge ? 'tw:text-lg' : 'tw:text-sm'" :title="formatDate(momentDatetime, 'LLL zz')">
            <span v-if="calendar">{{ momentDatetime.calendar() }}</span>
            <span v-else>{{ formatDate(momentDatetime, format) }}</span>
        </span>
    </e-tooltip>
</template>

<script>
export default {
    name: 'DatetimeDisplay',

    props: {
        datetime: {
            type: [Object, String],
            required: true,
        },

        isLarge: {
            type: Boolean,
            required: false,
            default: false,
        },

        format: {
            type: String,
            required: false,
            default: 'LLL zz',
        },

        calendar: {
            type: Boolean,
            required: false,
            default: false,
        },

        local: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        momentDatetime() {
            if (typeof this.datetime === 'string') {
                return this.local
                    ? this.$moment(this.datetime)
                    : this.$moment.utc(this.datetime).tz(this.$timezone.name);
            }

            return this.datetime;
        },
    },
};
</script>
